import { Container, Title, Text, Stack } from '@mantine/core';

export default function AdminDashboard() {
  return (
    <Container size="md" py="xl">
      <Stack gap="xl">
        <Title order={2}>管理者ダッシュボード</Title>
        <Text>管理者向けの機能は開発中です。</Text>
      </Stack>
    </Container>
  );
} 